import { collection, getDocs, query, where, serverTimestamp } from 'firebase/firestore';
import { db } from './config';
import { createEducation } from './educationService';

/**
 * Seed education if the collection is empty
 */
export const seedEducation = async () => {
    try {
        // Check if education entries already exist
        const educationCollection = collection(db, 'education');
        const snapshot = await getDocs(educationCollection);

        if (snapshot.empty) {
            console.log('Seeding education collection...');

            // Define initial education entries
            const initialEducation = [
                {
                    institution: 'Bangladesh University of Engineering and Technology',
                    degree: 'Master of Science in Engineering',
                    fieldOfStudy: 'Computer Science and Engineering',
                    location: 'Dhaka, Bangladesh',
                    startDate: '2022-06',
                    endDate: '2024-06',
                    grade: '',
                    descriptions: [
                        'Research focus on Machine Learning and Natural Language Processing',
                        'Developed novel approaches to Bengali language processing with transformer models',
                        'Coursework included Advanced Algorithms, Artificial Intelligence, and Cloud Computing'
                    ],
                    achievements: [
                        'Graduate Research Excellence Award for thesis work on transformer models',
                        'Published research in an international conference on machine learning applications'
                    ],
                    website: 'https://buet.ac.bd',
                    institutionLogo: '',
                    order: 0
                },
                {
                    institution: 'Rajshahi University',
                    degree: 'Bachelor of Science in Engineering',
                    fieldOfStudy: 'Electrical and Electronic Engineering',
                    location: 'Rajshahi, Bangladesh',
                    startDate: '2016',
                    endDate: '2021',
                    grade: 'CGPA 3.64/4.00',
                    descriptions: [
                        'Focused on embedded systems, signal processing, and computer architecture',
                        'Senior thesis: "Development of an IoT-based Smart Water Metering System"',
                        'Laboratory work included digital signal processing, microcontroller programming, and VLSI design'
                    ],
                    achievements: [
                        'University Merit Scholarship for academic excellence (2018-2020)',
                        'Best Undergraduate Project Award for IoT-based water metering system'
                    ],
                    website: 'https://ru.ac.bd',
                    institutionLogo: '',
                    order: 1
                }
            ];

            // Add each education entry
            for (const education of initialEducation) {
                await createEducation(education);
            }

            console.log('Education seeded successfully');
        } else {
            console.log('Education collection already has data, skipping seed');
        }
    } catch (error) {
        console.error('Error seeding education:', error);
    }
};

export default seedEducation; 